import type { DeepPartial } from '@luna/utils-ts';

import type { Export } from '../../types/Export';

export const exportHRFeatureConfig: DeepPartial<Export> = {
    disableFieldsByFormat: {
        csv: {
            type: [
                'performance',
                'performancePercent',
                'avgPurchasePrice',
                'totalIncome',
                'amount',
            ],
        },
        xls: {
            type: ['amount'],
        },
    },
    extraFields: [
        { key: 'numberOfShares' },
        { key: 'portfolioMarketValue' },
        { key: 'investedAmount' },
        {
            key: 'portfolioPerformanceQuarter',
        },
    ],
    hideSectionsFilter: true,
    hideSubPortfolioFilter: true,
    hideTitlesFilter: true,
};
